export default __webpack_public_path__ + "static/media/58_desktop.e2b6eb9e.jpg";